export function Changelog() {
  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white shadow">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <h1 className="text-3xl font-bold text-gray-900">Changelog</h1>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="space-y-8">
          {/* Version 0.2.1 */}
          <div className="bg-white rounded-lg shadow p-6">
            <div className="flex items-baseline gap-3 mb-4">
              <h2 className="text-2xl font-bold text-gray-900">v0.2.1</h2>
              <span className="text-sm text-gray-500">January 1, 2026</span>
            </div>
            <div className="space-y-4">
              <div>
                <h3 className="text-sm font-semibold text-gray-900 mb-2">Added</h3>
                <ul className="list-disc list-inside space-y-1 text-gray-700">
                  <li>Webcam video recording with direct upload to Cloudflare Stream</li>
                  <li>Stream video playback with iframe player on entry detail page</li>
                  <li>Horizontal flip toggle for webcam recording (mirror mode)</li>
                  <li>Canvas-based video flipping to record mirrored video</li>
                  <li>Flip preference persisted in localStorage per user</li>
                  <li>Stream video deletion when entry is deleted (cleanup)</li>
                  <li>New side panel navigation layout</li>
                  <li>Version number displayed in header (v0.2.1)</li>
                  <li>Changelog page to track updates</li>
                </ul>
              </div>
              <div>
                <h3 className="text-sm font-semibold text-gray-900 mb-2">Improved</h3>
                <ul className="list-disc list-inside space-y-1 text-gray-700">
                  <li>Entry cards on home page now auto-fit to content height (no white gaps)</li>
                  <li>Entire entry card is now clickable to view details</li>
                  <li>Delete button remains functional and positioned in bottom-right</li>
                </ul>
              </div>
              <div>
                <h3 className="text-sm font-semibold text-gray-900 mb-2">Fixed</h3>
                <ul className="list-disc list-inside space-y-1 text-gray-700">
                  <li>Duration now displays correctly for live-recorded audio entries</li>
                  <li>Duration now calculates properly for uploaded audio/video files</li>
                  <li>Audio player duration fallback prevents "Infinity:NaN" display on CORS issues</li>
                  <li>Fixed decimal seconds bug in duration formatting</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Version 0.2.0 */}
          <div className="bg-white rounded-lg shadow p-6">
            <div className="flex items-baseline gap-3 mb-4">
              <h2 className="text-2xl font-bold text-gray-900">v0.2.0</h2>
              <span className="text-sm text-gray-500">December 2025</span>
            </div>
            <div className="space-y-4">
              <div>
                <h3 className="text-sm font-semibold text-gray-900 mb-2">Added</h3>
                <ul className="list-disc list-inside space-y-1 text-gray-700">
                  <li>Video upload support with presigned URLs</li>
                  <li>Direct upload to R2 storage</li>
                  <li>Video player on entry detail page</li>
                  <li>Upload progress tracking</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Version 0.1.0 */}
          <div className="bg-white rounded-lg shadow p-6">
            <div className="flex items-baseline gap-3 mb-4">
              <h2 className="text-2xl font-bold text-gray-900">v0.1.0</h2>
              <span className="text-sm text-gray-500">Initial Release</span>
            </div>
            <div className="space-y-4">
              <div>
                <h3 className="text-sm font-semibold text-gray-900 mb-2">Added</h3>
                <ul className="list-disc list-inside space-y-1 text-gray-700">
                  <li>Audio recording from browser microphone</li>
                  <li>Audio file upload</li>
                  <li>Automatic transcription with word-level timestamps</li>
                  <li>Clickable transcript for seeking audio playback</li>
                  <li>Entry management (create, view, delete)</li>
                  <li>Google OAuth authentication</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
